<script setup lang="ts">
import {Head, router, useForm} from "@inertiajs/vue3";
import AuthLayout from "@/layouts/AuthLayout.vue";
import {route} from "ziggy-js";
import VFieldLabel from "@/components/forms/VFieldLabel.vue";

defineOptions({layout: AuthLayout})

const form = useForm({
    email: '',
    first_name: '',
    last_name: '',
    password: '',
    password_confirmation: '',
})

const submit = () => {
    form.post(route('register.store'), {
        preserveScroll: true
    })
}

const login = () => {
    router.visit(route('login'))
}
</script>

<template>
    <Head title="Create Account ⋅ Capacity Framework Portal" />
    <v-card
        variant="flat"
        class="justify-center"
    >
        <v-form @submit.prevent="submit">
            <v-card-title class="text-center text-h4 text-pre-wrap">
                <p>
                    Create an account
                </p>
                <p class="text-h5 text-medium-emphasis">
                    Fill in the details below to register
                </p>
            </v-card-title>
            <v-card-text class="mt-3 px-3 pb-3">
                <v-row>
                    <v-col
                        cols="12"
                        sm="6"
                    >
                        <v-field-label>
                            First name
                        </v-field-label>
                        <v-text-field
                            v-model="form.first_name"
                            name="first_name"
                            autocomplete="first_name"
                            class="mb-3"
                            :hide-details="!form.errors.first_name"
                            :error-messages="form.errors.first_name"
                            autofocus
                        />
                    </v-col>
                    <v-col
                        cols="12"
                        sm="6"
                    >
                        <v-field-label>
                            Last name
                        </v-field-label>
                        <v-text-field
                            v-model="form.last_name"
                            name="last_name"
                            autocomplete="last_name"
                            class="mb-3"
                            :hide-details="!form.errors.last_name"
                            :error-messages="form.errors.last_name"
                        />
                    </v-col>
                </v-row>
                <v-field-label>
                    Email address
                </v-field-label>
                <v-text-field
                    v-model="form.email"
                    type="email"
                    name="email"
                    autocomplete="email"
                    class="mb-3"
                    :hide-details="!form.errors.email"
                    :error-messages="form.errors.email"
                />
                <v-field-label>
                    Password
                </v-field-label>
                <v-text-field
                    v-model="form.password"
                    type="password"
                    name="password"
                    autocomplete="password"
                    class="mb-3"
                    :hide-details="!form.errors.password"
                    :error-messages="form.errors.password"
                />
                <v-field-label>
                    Confirm password
                </v-field-label>
                <v-text-field
                    v-model="form.password_confirmation"
                    type="password"
                    name="password_confirmation"
                    autocomplete="password_confirmation"
                    class="mb-3"
                    :hide-details="!form.errors.password_confirmation"
                    :error-messages="form.errors.password_confirmation"
                />
            </v-card-text>
            <v-card-actions class="pt-0">
                <v-btn
                    variant="flat"
                    type="submit"
                    :loading="form.processing"
                    block
                >
                    Register
                </v-btn>
            </v-card-actions>
        </v-form>
        <p class="text-body-2 text-center mt-3">
            Already have an account? <span
                class="text-primary custom-link"
                @click="login"
            >
                Log in
            </span>
        </p>
    </v-card>
</template>

<style scoped>

</style>
